import React from "react";
import type { CatalogStatus } from "../../types/catalog";
import { CATALOG_STATUS_LABELS } from "../../types/catalog";
import "./CatalogStatusTag.css";

const STATUS_CLASS: Record<CatalogStatus, string> = {
  OK: "catalog-status-tag--success",
  PARTIAL: "catalog-status-tag--warning",
  SIESA_CATALOG_MISSING: "catalog-status-tag--warning",
  PRODUCT_MISSING: "catalog-status-tag--error",
  DUPLICATE_PRODUCT: "catalog-status-tag--info",
  SKU_MISSING: "catalog-status-tag--error",
  SYNC_ERROR: "catalog-status-tag--error",
};

interface CatalogStatusTagProps {
  status: CatalogStatus;
}

const CatalogStatusTag: React.FC<CatalogStatusTagProps> = ({ status }) => (
  <span
    className={`catalog-status-tag ${
      STATUS_CLASS[status] ?? "catalog-status-tag--default"
    }`}
  >
    {CATALOG_STATUS_LABELS[status] ?? status}
  </span>
);

export default CatalogStatusTag;
